document.addEventListener('DOMContentLoaded', () => {
  const onClickCookieBotLink = (event) => {
    event.preventDefault()

    if (!window.OneTrust) return

    window.OneTrust.ToggleInfoDisplay()
  }

  const actionCookieBot = document.querySelectorAll('[data-cookiebot-renew]')

  if (!actionCookieBot.length) return

  actionCookieBot.forEach(item => {
    item.addEventListener('click', onClickCookieBotLink)
  })
})
